module.exports = __webpack_public_path__ + "images/emoji/u6709.2c3bd5be107ac6064ed1.png";